/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_Core_Dtos_ListResultDto_1 } from '../models/Routemize_Core_Dtos_ListResultDto_1';
import type { Routemize_Core_Dtos_PagedResultDto_1 } from '../models/Routemize_Core_Dtos_PagedResultDto_1';
import type { Routemize_DTOs_Identity_IdentityRoleDto } from '../models/Routemize_DTOs_Identity_IdentityRoleDto';
import type { Routemize_DTOs_Identity_IdentityRoleDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_Identity_IdentityRoleDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RoleService {
    /**
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns Routemize_Core_Dtos_PagedResultDto_1<Routemize_DTOs_Identity_IdentityRoleDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static getApiIdentityRoles(
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<Routemize_Core_Dtos_PagedResultDto_1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/roles',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
        });
    }
    /**
     * @returns Routemize_Core_Dtos_ListResultDto_1<Routemize_DTOs_Identity_IdentityRoleDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static getApiIdentityRolesAll(): CancelablePromise<Routemize_Core_Dtos_ListResultDto_1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/roles/all',
        });
    }
    /**
     * @param id
     * @returns Routemize_DTOs_Identity_IdentityRoleDto OK
     * @throws ApiError
     */
    public static getApiIdentityRoles1(
        id: string,
    ): CancelablePromise<Routemize_DTOs_Identity_IdentityRoleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/roles/{id}',
            path: {
                'id': id,
            },
        });
    }
}
